module.exports = __webpack_public_path__ + "media/shipment/OMNIVA-fe48e623.svg";